
<app-navbar-style-two></app-navbar-style-two>
<div class="container blog-container">
  <div class="blog-area">
      <div class="blog-header text-center">
        <h2>{{ tempVideo.title }}</h2>
      </div>
  </div>
  <div class="blog-content-area">
    <div class="blog-card">
      <div class="blog-image-container">
        <iframe  [src]="videoUrl"
        frameborder="0" allowfullscreen></iframe>
      </div>
      <div class="blog-content">
        <div class="blog-description-wrapper" [innerHTML]="tempVideo.more_description"></div>
        <div class="blog-cta">
             <a *ngIf="tempVideo.cta_button_enabled && !tempVideo.togglecontrol" [href]="tempVideo.cta_button_link" class="cta-button">{{tempVideo.cta_button_text}}</a>
              <a *ngIf="tempVideo.cta_button_enabled && tempVideo.togglecontrol" (click)="openLandingpage(tempVideo.cta_button_source_name)" class="cta-button">{{tempVideo.cta_button_text}}</a>
        </div>
      </div>
    </div>
  </div>

</div>
<app-footer-style-two></app-footer-style-two>
